import { Component, OnInit, AfterViewInit, ViewChild, ElementRef } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { ConfiguracaoEventoService } from 'src/services/configuracao-evento.service';
import { TipoVariavelService } from 'src/services/tipo-variavel.service';
import { PermissoesService } from 'src/services/permissoes.service';
import { MessageService, ConfirmationService } from 'primeng/api';

@Component({
    selector: 'app-cadastro-evento',
    templateUrl: './cadastro-evento.component.html',
    styleUrls: ['./cadastro-evento.component.scss'],
    standalone: false
})
export class CadastroEventoComponent implements OnInit, AfterViewInit {
  data: any[] = [];
  form: FormGroup;
  displayModal: boolean = false;
  loading: boolean = false;
  dropDownTipoVariavel: any[] = [];
  direitoInserir: boolean = false;
  direitoEditar: boolean = false;
  direitoExcluir: boolean = false;
  @ViewChild('tableWrapper', { static: false }) tableWrapper: ElementRef;
  scrollHeight: string = '600px';

  constructor(
    protected _formBuilder: FormBuilder,
    protected _configuracaoEventoService: ConfiguracaoEventoService,
    protected _tipoVariavelService: TipoVariavelService,
    protected permissaoService: PermissoesService,
    private messageService: MessageService,
    private confirmationService: ConfirmationService,
  ) { }

  ngOnInit(): void {
    this.direitoInserir = true;
    this.direitoEditar = true;
    this.direitoExcluir = this.permissaoService.can('cadastro_eventos_excluir') ?? true;

    this.form = this._formBuilder.group({
      id: [null],
      descricao_evento: [null],
      tipo_variavel_coleta: [null],
      gerar_cosolidacao_diaria: [true],
      valor_padrao: [null],
    })

    this.index()
    this.carregarTipoVariavel()
  }

  ngAfterViewInit(): void {
    setTimeout(() => {
      this.calculateScrollHeight();
    }, 200);
  }

  calculateScrollHeight(): void {
    if (this.tableWrapper && this.tableWrapper.nativeElement) {
      const wrapperHeight = this.tableWrapper.nativeElement.offsetHeight;
      const calculatedHeight = wrapperHeight - 120;
      this.scrollHeight = `${Math.max(calculatedHeight, 300)}px`;
    }
  }

  index(){
    this._configuracaoEventoService.index().subscribe(json => {
      this.data = json || [];
      setTimeout(() => {
        this.calculateScrollHeight();
      }, 200);
    })
  }

  carregarTipoVariavel(){
    this._tipoVariavelService.index().subscribe(json => {
      this.dropDownTipoVariavel = json.map(item => ({
        label: item.tipo_variavel || `ID: ${item.id}`,
        value: item.id
      }))
    })
  }

  openNew(){
    this.form.reset()
    this.displayModal = true
  }

  edit(event){
    this._configuracaoEventoService.show(event.id).subscribe(json => {
      this.form.patchValue(json); 
      this.displayModal = true;
    })
  }

  save(){
    this.loading = true;
    let form = this.form.value;
    
    // tipo_variavel_coleta pode ser null (opcional)
    let params: any = {
      descricao_evento: form.descricao_evento,
      tipo_variavel_coleta: form.tipo_variavel_coleta || null,
      gerar_cosolidacao_diaria: form.gerar_cosolidacao_diaria !== null ? form.gerar_cosolidacao_diaria : true,
      valor_padrao: form.valor_padrao || null,
    };    

    if (form.id == null) {
      // Para novo registro, enviamos tipo_variavel_evento como 0 (valor temporário)
      // Depois atualizamos para definir tipo_variavel_evento = id gerado
      params.tipo_variavel_evento = 0;
      
      this._configuracaoEventoService.store(params).subscribe(json => {
          // Após criar, atualizamos para definir tipo_variavel_evento = id
          const updateParams = {
            descricao_evento: json.descricao_evento,
            tipo_variavel_evento: json.id,
            tipo_variavel_coleta: json.tipo_variavel_coleta || null,
            gerar_cosolidacao_diaria: json.gerar_cosolidacao_diaria !== undefined ? json.gerar_cosolidacao_diaria : true,
            valor_padrao: json.valor_padrao || null,
          };
          
          this._configuracaoEventoService.update(updateParams, json.id).subscribe(updatedJson => {
            this.loading = false;
            this.index();
            this.displayModal = false;
          }, err => {
            this.loading = false;
            this.index();
            this.displayModal = false;
          });
      }, err => {
        this.loading = false;
      });
    } else {
      // Para edição, tipo_variavel_evento = id
      params.tipo_variavel_evento = form.id;
      
      this._configuracaoEventoService.update(params, form.id).subscribe(json => {
          this.loading = false;
          this.index();
          this.displayModal = false;
      }, err => {
        this.loading = false;
      });
    }
  }

  /**
   * Confirmação Sim/Não antes de excluir. Chama DELETE (configuracao-evento ou dados-eventos).
   * Documentação: DELETE /api/dados-eventos/{id} — 204 sucesso, 404 dado de evento não encontrado.
   */
  confirmarExclusao(evento: any): void {
    const descricao = evento.descricao_evento || `ID ${evento.id}`;
    this.confirmationService.confirm({
      key: 'globalConfirm',
      message: `Deseja realmente excluir o evento "${descricao}" (código ${evento.id})?`,
      header: 'Confirmar exclusão',
      icon: 'pi pi-exclamation-triangle',
      acceptLabel: 'Sim, excluir',
      rejectLabel: 'Cancelar',
      acceptButtonStyleClass: 'p-button-danger',
      accept: () => this.excluirEvento(evento.id),
    });
  }

  private excluirEvento(id: number): void {
    this._configuracaoEventoService.destroy(id).subscribe({
      next: () => {
        this.data = this.data.filter((item: any) => item.id !== id);
        this.messageService.add({
          severity: 'success',
          summary: 'Sucesso',
          detail: 'Evento excluído com sucesso.',
        });
        setTimeout(() => this.calculateScrollHeight(), 200);
      },
      error: (err) => {
        const status = err?.status;
        const body = err?.error || {};
        const msg = body?.message || body?.error || 'Não foi possível excluir o evento.';
        if (status === 404) {
          this.data = this.data.filter((item: any) => item.id !== id);
          this.messageService.add({
            severity: 'warn',
            summary: 'Atenção',
            detail: msg,
          });
        } else {
          this.messageService.add({
            severity: 'error',
            summary: 'Erro',
            detail: msg,
          });
        }
      },
    });
  }
}

